import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserLink from './UserLink';
import UserLinkPopover from './UserLinkPopover';
export const UserLinkWithTooltip = (_param)=>{
    var { user , className , contentClassName , biData , relatedItemBiData , withTooltip  } = _param, props = _object_without_properties(_param, [
        "user",
        "className",
        "contentClassName",
        "biData",
        "relatedItemBiData",
        "withTooltip"
    ]);
    const isMobile = useContext(MobileContext);
    // in some cases this could be null, example deviation.author
    if (!user) {
        return null;
    }
    // TODO: use isGroup util function
    const isGroup = user.type && user.type.includes('group');
    const shouldRenderTooltip = withTooltip && !isMobile && !isGroup;
    if (!shouldRenderTooltip) {
        return /*#__PURE__*/ React.createElement(UserLink, _extends({
            user: user,
            className: classnames(className, contentClassName),
            biData: biData
        }, props));
    }
    return /*#__PURE__*/ React.createElement(UserLinkPopover, {
        user: user,
        className: className,
        relatedItemBiData: relatedItemBiData,
        biData: biData
    }, /*#__PURE__*/ React.createElement(UserLink, _extends({
        user: user,
        className: contentClassName
    }, props)));
};
UserLinkWithTooltip.displayName = 'UserLinkWithTooltip';
export default UserLinkWithTooltip;
